import { RoutersType } from "../type/routes";
import ErrorPage from "../pages/errorPage/error";
import Error401Page from "../pages/errorPage/error401";
import SCRC010003 from "../pages/SCRC010003";

const routes: RoutersType[] = [
  {
    path: "/error",
    component: ErrorPage,
    name: "error",
    meta: {
      title: "エラー",
      isErrorPage: true,
      dnotShowInBreadcrumb: true,
    },
  },
  {
    path: "/error401",
    component: Error401Page,
    name: "error401",
    meta: {
      title: "エラー",
      isErrorPage: true,
      dnotShowInBreadcrumb: true,
    },
  },
  {
    name: "パスワード変更",
    path: "/SCRC010003",
    component: SCRC010003,
    meta: {
      title: "パスワード変更",
      // メニューアイテムを非表示にするかどうか
      hidden: true,
      isMenuContent: true,
      isErrorPage: false,
      dnotShowInBreadcrumb: false,
    },
  },
];

export { routes };
